import debugHost from '../Utils/debugHost';
import { DeviceInfo } from 'qunar-react-native'

// qrn fetch 请求的host作为默认地址
let ORDER_HOTS = 'https://order.qunar.com';
if(DeviceInfo && DeviceInfo.platform && DeviceInfo.platform.toUpperCase() === 'WEB'){
    // web端，注意跨域问题
    ORDER_HOTS = window.location.origin;
    // ORDER_HOTS = 'https://order.qunar.com';
} else if(DeviceInfo && DeviceInfo.platform && DeviceInfo.platform.toUpperCase() === 'WECHAT') {
    ;
}

// ORDER_HOTS = 'http://dev.qunar.com';
// ORDER_HOTS = 'http://yapi.corp.qunar.com/mock/6603/order-three';
// ORDER_HOTS = 'http://l-noah6lisjb10f1.auto.beta.cn0.qunar.com:9002';
// ORDER_HOTS = 'http://l-userorder1.user.cn1.qunar.com:8080';
interface PageUrlsMode {
    bindList: string;
    searchByPhone: string;
}

/**
 * ! new_r参数有两个作用
 * 1. 值是随机数保证页面刷新
 * 2. new_r能够修改二级页面的返回逻辑，解决参数直接丢弃导致展示酒店筛选的错误并保证旧列表页的正常访问
 */
const PAGE_URLS: PageUrlsMode = {
    bindList: `${ORDER_HOTS}/mordercenter/v2/index.html?hybridid=mob_ordercenter#bindList`,
    searchByPhone: `${ORDER_HOTS}/mordercenter/v2/index.html?hybridid=mob_ordercenter#searchByPhone`
};

export default debugHost(PAGE_URLS, ORDER_HOTS, 'PAGE_URLS');
